import React from 'react'
import Sidebar from '../Sidebar/Sidebar'
import { useDispatch, useSelector } from 'react-redux'
import { getAllSubscriptions, getWhatIsMyBusiness } from '../../../Redux/Actions/UserAction'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getSettingsSidebarOptions } from '../../settingsPages/sidebarOptions'

const Package = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllSubscriptions());
    dispatch(getWhatIsMyBusiness());
  }, [dispatch])

  const packages = useSelector(state => state.home.allPackages);
  const getMybusiness = useSelector(state => state.home?.getMybusiness);

  const sideBarOpt = getSettingsSidebarOptions(t, getMybusiness);

  const ui = {
    card: {
      background: '#fff',
      border: '1px solid #eee',
      borderRadius: '14px',
      boxShadow: '0 6px 20px rgba(0,0,0,0.05)',
      overflow: 'hidden',
      marginBottom: '1.75rem',
    },
    head: {
      background: '#1a1a1a',
      color: '#fff',
      padding: '14px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    headTitle: { fontSize: '1rem', fontWeight: 700, margin: 0, letterSpacing: '.3px' },
    badge: {
      background: '#FEBA00',
      color: '#1a1a1a',
      fontWeight: 700,
      fontSize: '.8rem',
      padding: '4px 12px',
      borderRadius: '999px',
      textTransform: 'uppercase',
      letterSpacing: '.5px',
    },
    body: { padding: '6px 20px 14px' },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 0',
      borderBottom: '1px solid #f1f1f1',
    },
    label: { color: '#777', fontSize: '.92rem' },
    value: { color: '#1a1a1a', fontWeight: 600, fontSize: '.95rem' },
    sectionTitle: {
      fontSize: '1.05rem',
      fontWeight: 700,
      color: '#1a1a1a',
      margin: '0 0 1rem',
    },
    empty: {
      background: '#fff',
      border: '1px dashed #ddd',
      borderRadius: '14px',
      padding: '28px 20px',
      textAlign: 'center',
      color: '#777',
    },
    histItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '14px',
      background: '#fff',
      border: '1px solid #eee',
      borderRadius: '12px',
      padding: '14px 18px',
      marginBottom: '12px',
    },
    histIndex: {
      flex: '0 0 34px',
      height: '34px',
      width: '34px',
      borderRadius: '50%',
      background: '#f5f5f5',
      color: '#1a1a1a',
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '.85rem',
    },
    histMain: { flex: '1 1 auto', display: 'flex', flexWrap: 'wrap', gap: '4px 18px' },
    histPkg: { fontWeight: 700, color: '#1a1a1a' },
    histMeta: { color: '#777', fontSize: '.9rem' },
    histAmount: {
      fontWeight: 700,
      color: '#1a1a1a',
      whiteSpace: 'nowrap',
      background: '#fff7e0',
      border: '1px solid #ffe7a3',
      borderRadius: '999px',
      padding: '4px 12px',
      fontSize: '.88rem',
    },
  }

  const Row = ({ label, value }) => (
    <div style={ui.row}>
      <span style={ui.label}>{label}</span>
      <span style={ui.value}>{value}</span>
    </div>
  )

  return (
    <div>
      <div className='main-content-area'>
        <div className='container'>
          <h2 className='mb-4'>{t('Settings')}</h2>
          <div className='row justify-content-between'>
            <Sidebar options={sideBarOpt} showPackage={false} />

            <div className='col-12 col-sm-12 col-md-9 col-lg-9'>
              <h5 style={ui.sectionTitle}>{t('Current Subscription')}</h5>

              {packages?.current ? (
                <div style={ui.card}>
                  <div style={ui.head}>
                    <p style={ui.headTitle}>{t('Active Plan')}</p>
                    <span style={ui.badge}>{packages?.current?.packageId}</span>
                  </div>
                  <div style={ui.body}>
                    <Row
                      label={t('Duration')}
                      value={`${packages?.current?.duration || 0} ${t('Days')}`}
                    />
                    <Row label={t('Started on')} value={packages?.current?.startDate} />
                    <div style={{ ...ui.row, borderBottom: 'none' }}>
                      <span style={ui.label}>{t('Ends on')}</span>
                      <span style={{ ...ui.value, color: '#FEBA00' }}>
                        {packages?.current?.expiry}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div style={ui.empty}>
                  {packages?.message || t('You do not have an active subscription.')}
                </div>
              )}

              {packages?.data?.length > 0 && (
                <>
                  <h5 style={ui.sectionTitle}>{t('Subscription History')}</h5>
                  {packages?.data?.map((dt, ind) => (
                    <div key={ind} style={ui.histItem}>
                      <div style={ui.histIndex}>{ind + 1}</div>
                      <div style={ui.histMain}>
                        <span style={ui.histPkg}>{dt?.packageId}</span>
                        <span style={ui.histMeta}>
                          {dt?.days || 0} {t('Days')}
                        </span>
                      </div>
                      <span style={ui.histAmount}>{dt?.amount || 0} KWD</span>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Package
